import React, { FunctionComponent } from "react";

const MultipleNeutralIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/users/geomertic-close-up-multiple-users/multiple-neutral-1
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.375 7.875 A4.125 4.125 0 1 0 11.625 7.875 A4.125 4.125 0 1 0 3.375 7.875 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M.75,20.25a6.75,6.75,0,0,1,13.5,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.251,4.416a4.125,4.125,0,1,1-.006,6.914"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15,13.667a6.757,6.757,0,0,1,8.25,6.583"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default MultipleNeutralIcon;
